import React, { useState } from 'react'
import styles from './index.module.css'
import Table from '../../../../components/Table'
import { BiTrash } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'
import { createStudyPlan, createStudyPlanContent, deleteStudyPlansContent, editStudyPlan, editStudyPlanContent } from '../../../../actions/studyPlans'
import Confirmation from '../../../../components/Confirmation/Confirmation'
import Button from '../../../../components/Button'
import Modal from './Modal'
import { createNotification } from '../../../../components/Notifications/Notifications'
import moment from 'moment'
import { addStudyPlanDOCourse } from '../../../../actions/studyPlansDO'


const Index = ({ data, closeModal, height, addMode, classGroup, values, setFieldValue, handleChange, handleSubmit }) => {

    const dispatch = useDispatch();
    const { listDO, coursesListDO } = useSelector(state => state.studyPlansDO)
    const [compoundModalOpen, setCompoundModalOpen] = useState(null);


    const [confirmation, setConfirmation] = useState(false);
    const [modalOpen, setModalOpen] = useState(null);

    const acceptConfirmation = () => { // Подтвердить удаление
        closeModal();
        setConfirmation(false);
    };
    const rejectConfirmation = () => { // Отменить подтверждение
        setConfirmation(false);
    };

    const openModal = (item) => { // Открыть модалку
        if (item?.xp_key) {
            setCompoundModalOpen(item)
        } else {
            setCompoundModalOpen({})
        }


    }

    const closeSubModal = () => { // Закрыть модалку
        setCompoundModalOpen(null)
    }

    const handleConfirmation = (e, data) => {
        e.stopPropagation() // Отмена действия по умолчанию (открытие модалки)
        setConfirmation(data)
    }


    return (
        <div className={styles.tabWrapper}>
            {!!coursesListDO &&

                <Table className={styles.table}>
                    <thead>
                        <tr>
                            <th>№ п/п</th>
                            <th>Уч. план</th>
                            <th>Предмет</th>
                            <th>Часы в год</th>
                            <th>Часы в неделю</th>
                            <th>Параллель</th>
                            <th>Удалить</th>
                        </tr>
                    </thead>
                    {coursesListDO?.map((data, index) => (
                        <tbody>
                            <tr key={index} onClick={() => openModal(data)}>
                                <td>{index + 1}</td>
                                <td>{listDO.find(el => el.xp_key === data.xp_tracks).name}</td>
                                <td>{data.name}</td>
                                <td>{data.hours}</td>
                                <td>{data.hoursweek}</td>
                                <td>{data.level}</td>
                                <td onClick={(e) => handleConfirmation(e, data)}>
                                    <i className={styles.trash}><BiTrash /></i>
                                </td>
                            </tr>
                        </tbody>
                    ))
                    }

                </Table>
            }
            {compoundModalOpen && (
                <div className={styles.modal}>
                    <Modal
                        closeModal={closeSubModal}
                        // handleSubmit={handleSubmitSub}
                        compoundModalOpen={compoundModalOpen}
                        setCompoundModalOpen={setCompoundModalOpen}
                        addMode={!compoundModalOpen.xp_key}
                        xp_tracks={data.xp_key}
                    /></div>
            )}

            <div className={styles.buttons}>
                <Button
                    style={{
                        backgroundColor: "#3689FF",
                        fontSize: "16px"
                    }}
                    onClick={() => openModal()}>Добавить</Button>
            </div>

            {confirmation && (<Confirmation
                top="30px"
                left="40px"
                title="Удалить данную запись?"
                confirmation={confirmation
                    ?.name}
                acceptConfirmation={() => acceptConfirmation(confirmation
                    ?.name)}
                rejectConfirmation={rejectConfirmation} />)}
        </div>
    )
}

export default Index